import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MDXProvider } from '@mdx-js/react';
import App from './App';
import { I18nProvider } from './i18n';
import { ThemeProvider } from './lib/theme';
import { mdxComponents } from './components/mdxComponents';
import './styles/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <BrowserRouter>
          <MDXProvider components={mdxComponents}>
            <App />
          </MDXProvider>
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
